import React, { useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import logo from '../../assets/logo.png';
import api from '../../controller/api';
import { toast, Toaster } from "sonner"
import { BiLoader } from "react-icons/bi"
import { FcGoogle } from "react-icons/fc";
import { useGoogleLogin } from "@react-oauth/google"
import loginImg from "../../assets/doctor-login.png"

export default function Register() {
    const [name, setName] = useState("")
    const [username, setUsername] = useState("")
    const [password, setPassword] = useState("")
    const [accountType, setAccountType] = useState("")
    const [loading, setLoading] = useState(false)

    const navigate = useNavigate()

    const handleSignup = async (e) => {
        e.preventDefault()
        setLoading(true)
        try {
            if (!name) {
                return toast.error("Enter the name");
            }
            if (username.length < 5 || password.length < 5) {
                return toast.error(
                    "Username and password should not be minimum of 5 character"
                );
            }

            const userData = {
                name: name,
                username: username,
                password: password,
                accountType: accountType
            }

            const { data: res } = await api.post("/user/create", userData)
            if (res?.user) {
                toast.success("User created successfully")
                setTimeout(() => {
                    navigate("/login")
                }, 1500)
            }

        } catch (error) {
            console.error(error)
            toast.error(error?.response?.data?.message)
        } finally {
            setLoading(false)
        }
    }

    const responseGoolge = async (authResult) => {
        try {
            if (authResult['code']) {
                const code = authResult['code']
                const data = await api.post("/user/google-signup", { code })

                if (data?.status === "error") {
                    toast.error("User already added")
                    setTimeout(() => {
                        navigate('/login');
                    }, 1500)
                }
                toast.success("Account created")
                setTimeout(() => {
                    navigate('/login');
                }, 1500)
            }
        } catch (error) {
            console.log(error);
            if (error?.response?.data?.status === "error") {
                toast.error("User already added")
                setTimeout(() => {
                    navigate('/login');
                }, 1500)
            }
        }
    }

    const googleLogin = useGoogleLogin({
        onSuccess: responseGoolge,
        onError: responseGoolge,
        flow: "auth-code"
    })

    return <div className='login-page'>
        <Toaster richColors position="top-center" />
        <div className='login-section'>
            <div className='login-img'><img src={loginImg} alt='Kogin Graphic' /></div>
            <div className="login-form">
                <Link to="/"><img src={logo} alt="Home Salon logo" className="login-logo" /></Link>
                <button
                    onClick={googleLogin}
                    className="google-btn"
                    type="submit"
                >
                    <FcGoogle style={{ width: "30px" }} />
                    SignUp with Google
                </button>
                <form onSubmit={handleSignup}>
                    <div className="input-box">
                        <label className="col-md-2 col-form-label">Name</label>
                        <input className="form-control" value={name} onChange={(e) => setName(e.target.value)} placeholder="Enter name" type="text" />
                    </div>
                    <div className="input-box">
                        <label className="col-md-2 col-form-label">User Name</label>
                        <input className="form-control" value={username} onChange={(e) => setUsername(e.target.value)} placeholder="Enter username" type="text" />
                    </div>
                    <div className="input-box">
                        <label className="col-md-2 col-form-label">Password</label>
                        <input className="form-control" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="Enter password" type="password" />
                    </div>
                    <div className="input-box">
                        <label className="col-md-2 col-form-label">Account Type</label>
                        <select value={accountType} onChange={(e) => setAccountType(e.target.value)}>
                            <option>Select Type</option>
                            <option value="hospital">Hospital</option>
                            <option value="patient">Patient</option>
                        </select>
                    </div>
                    <div className="input-box">
                        <button className='login-btn'>{loading ? <BiLoader size={24} className='animate-spin' /> : "Register"}</button>
                    </div>
                </form>
                <p><Link to="/login" className='btn-credential'>Login here</Link></p>
            </div>
        </div>
    </div>
}
